// src/pages/Career.jsx
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { submitCareer, clearCareerState } from "../../slice/careerSlice";

export default function Career() {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.career);

  const [formData, setFormData] = useState({
    service: "",
    name: "",
    number: "",
    location: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send JSON instead of FormData
    dispatch(submitCareer({ ...formData }));
  };

  useEffect(() => {
    if (success) {
      setFormData({ service: "", name: "", number: "", location: "" });
      const timer = setTimeout(() => {
        dispatch(clearCareerState());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, dispatch]);

  const textVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>
      <motion.section
        className="bg-gradient-to-r from-[#0464a4] to-[#34c3e3] text-white text-center py-24 px-4"
        initial="hidden"
        animate="visible"
        variants={textVariant}
      >
        <h1 className="text-5xl md:text-6xl font-bold mb-4">Join Our Team</h1>
        <p className="max-w-3xl mx-auto text-lg md:text-xl">
          Fill the form below and tell us which cleaning service you are interested in.
        </p>
      </motion.section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textVariant}
          className="bg-white p-8 md:p-12 rounded-2xl shadow-lg"
        >
          <h2 className="text-3xl font-bold mb-8 text-[#e58505] text-center">
            Career Form
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Service */}
            <div>
              <label htmlFor="service" className="block mb-2 font-medium text-gray-700">
                Select Service
              </label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#079dcc]"
              >
                <option value="">-- Choose a Service --</option>
                <option value="Home Cleaning">Home Cleaning</option>
                <option value="Office Cleaning">Office Cleaning</option>
                <option value="Carpet & Sofa Care">Carpet & Sofa Care</option>
                <option value="Industrial Cleaning">Industrial Cleaning</option>
                <option value="Window Cleaning">Window Cleaning</option>
                <option value="Kitchen Cleaning">Kitchen Cleaning</option>
              </select>
            </div>

            {/* Name */}
            <div>
              <label htmlFor="name" className="block mb-2 font-medium text-gray-700">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your full name"
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#079dcc]"
              />
            </div>

            {/* Phone */}
            <div>
              <label htmlFor="number" className="block mb-2 font-medium text-gray-700">Phone Number</label>
              <input
                type="tel"
                id="number"
                name="number"
                value={formData.number}
                onChange={handleChange}
                required
                placeholder="Enter your number"
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#079dcc]"
              />
            </div>

            {/* Location */}
            <div>
              <label htmlFor="location" className="block mb-2 font-medium text-gray-700">Location</label>
              <input
                type="text"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                placeholder="City or Area"
                className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#079dcc]"
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                disabled={loading}
                className="bg-[#e58505] text-white px-10 py-3 rounded-full font-semibold hover:bg-[#cf6e02] transition-colors disabled:opacity-50"
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>

            {success && <p className="text-center text-green-500 mt-2">Application submitted successfully!</p>}
            {error && <p className="text-center text-red-500 mt-2">Error: {typeof error === "string" ? error : JSON.stringify(error)}</p>}
          </form>
        </motion.div>
      </section>
    </>
  );
}
